import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { dateFormatter } from "../Utils/Dates";
import { useTranslation } from "react-i18next";

// Función para formatear celdas con valor nulo
const formatCell = (cell, _row, _rowIndex, defaultValue = "No disponible") => cell || defaultValue;

// Componente Principal de la Tabla
const PrescriptionsTable = ({ data, filters, totalSize, loading, onTableChange }) => {
  const { t } = useTranslation();

  // Columnas
  const getColumns = () => [
    {
      dataField: "prescriptionId",
      text: "ID",
      hidden: true,
    },
    {
      dataField: "date",
      text: t("medicalRecords.prescriptionReports.table.date"),
      formatter: (cell) => formatCell(dateFormatter(cell, "DD/MM/YYYY HH:mm")),
    },
    {
      dataField: "fullName",
      text: t("medicalRecords.prescriptionReports.table.fullName"),
      //formatter: formatCell,
    },
    {
      dataField: "dni",
      text: t("medicalRecords.prescriptionReports.table.dni"),
      //formatter: formatCell,
    },
    {
      dataField: "medicalRecordNumber",
      text: t("medicalRecords.prescriptionReports.table.medicalRecordNumber"),
      // formatter: formatCell,
    },
    {
      dataField: "affiliateNumber",
      text: t("medicalRecords.prescriptionReports.table.affiliateNumber"),
      //formatter: formatCell,
    },
    {
      dataField: "healthInsurance",
      text: t("medicalRecords.prescriptionReports.table.healthInsurance"),
      //   formatter: formatCell,
    },
    {
      dataField: "plan",
      text: t("medicalRecords.prescriptionReports.table.plan"),
      // formatter: formatCell,
    },
    {
      dataField: "prescriptionCount",
      text: t("medicalRecords.prescriptionReports.table.prescriptionCount"),
      // formatter: (cell) => formatCell(cell, "0"),
    },
    {
      dataField: "barcode",
      text: t("medicalRecords.prescriptionReports.table.barcode"),
      //  formatter: formatCell,
    },
    {
      dataField: "professional",
      text: t("medicalRecords.prescriptionReports.table.professional"),
      //formatter: formatCell,
    },
  ];

  return (
    <BootstrapTable
      remote
      keyField="prescriptionId"
      data={data}
      columns={getColumns()}
      bordered={false}
      hover
      classes="table-spaced table-striped table-hover"
      wrapperClasses="table-responsive"
      pagination={paginationFactory({
        page: filters.pagination.page,
        sizePerPage: filters.pagination.sizePerPage,
        totalSize: totalSize,
        hideSizePerPage: true,
        hidePageListOnlyOnePage: true
      })}
      noDataIndication={() =>
        loading ? (
          <div className="d-flex align-items-center justify-content-center text-muted py-4">
            <i className="fa fa-spinner fa-spin" style={{ marginRight: "0.5rem" }} />
            <span>{t("medicalRecords.prescriptionReports.table.loading")}</span>
          </div>
        ) : (
          <div className="text-center text-muted py-4">
            {t("medicalRecords.prescriptionReports.table.noResults")}
          </div>
        )
      }
      onTableChange={onTableChange}
    />
  );
};

export default PrescriptionsTable;
